import FileTableRow from './FileTableRow';
import FolderTableRow from './FolderTableRow';
import type { OneDriveFile, OneDriveFolder } from '../types';

type OneDriveItemTableRowProps = {
  oneDriveItem: OneDriveFile | OneDriveFolder;
  onOpenFolder: (
    folderName: string,
    folderItems: (OneDriveFile | OneDriveFolder)[],
  ) => void;
};

const OneDriveItemTableRow = ({
  oneDriveItem,
  onOpenFolder,
}: OneDriveItemTableRowProps) => {
  if ('folder' in oneDriveItem) {
    return <FolderTableRow folder={oneDriveItem} onOpen={onOpenFolder} />;
  }

  return <FileTableRow file={oneDriveItem} />;
};

export default OneDriveItemTableRow;
